/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待校验文本 'text' 和哈希值 'hash' 的JSON对象
 */
export type PostTextMd5VerifyRequest = { hash: string; text: string };

export const PostTextMd5VerifyRequest$zodSchema: z.ZodType<
  PostTextMd5VerifyRequest
> = z.object({
  hash: z.string(),
  text: z.string(),
}).describe("包含待校验文本 'text' 和哈希值 'hash' 的JSON对象");

export type PostTextMd5VerifyDetails = {};

export const PostTextMd5VerifyDetails$zodSchema: z.ZodType<
  PostTextMd5VerifyDetails
> = z.object({});

/**
 * 无效的请求参数
 */
export type PostTextMd5VerifyBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextMd5VerifyDetails | undefined;
  message?: string | undefined;
};

export const PostTextMd5VerifyBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextMd5VerifyBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextMd5VerifyDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("无效的请求参数");

/**
 * 成功响应
 */
export type PostTextMd5VerifyResponseBody = { match?: boolean | undefined };

export const PostTextMd5VerifyResponseBody$zodSchema: z.ZodType<
  PostTextMd5VerifyResponseBody
> = z.object({
  match: z.boolean().optional(),
}).describe("成功响应");

export type PostTextMd5VerifyResponse =
  | PostTextMd5VerifyResponseBody
  | PostTextMd5VerifyBadRequestResponseBody;

export const PostTextMd5VerifyResponse$zodSchema: z.ZodType<
  PostTextMd5VerifyResponse
> = z.union([
  z.lazy(() => PostTextMd5VerifyResponseBody$zodSchema),
  z.lazy(() => PostTextMd5VerifyBadRequestResponseBody$zodSchema),
]);
